import { otherRouter } from '@/router/router';
import * as api from '../../api';


const datalogger = {
  state: {
    dataLoggerInfos: [],
    dataLoggerPage: {},
    treeNodes: [],
    projectInfos: [],
    sensorInfos: [],
    sensorPoints: [],
    dataloggerPoints: [],
    legendData: [],
    chartData: {},
    tableColumns: [],
    tableData: [],
    dataloggertab: [],
    defaultTabId: ""
  },
  //此处进行数据转换
  mutations: {
    //采集器数据
    GETDATALOGGERINFOS(state, data) {
      state.dataLoggerInfos = data;
    },
    GETDATALOGGERPAGE(state, data) {
      state.dataLoggerPage = data;
    },
    //采集器树
    GETTREENODES(state, data) {
      state.treeNodes = data;
    },

    //传感器数据
    GETSENSORINFOS(state, data) {
      state.sensorInfos;
    },
    //地图传感器位置信息
    GETSENSORPOINTINFOS(state, data) {
      state.sensorPoints = [];
      for (var i = 0; i < data.length; i++) {
        var sensorInfo = data[i];
        var position = { lng: sensorInfo.longitude, lat: sensorInfo.latitude, type: 'sensor', id: sensorInfo.sensorId, sta: sensorInfo.sensorStatus, snt: sensorInfo.sensorType, d1: sensorInfo.lastData1, d2: sensorInfo.lastData2, d3: sensorInfo.lastData3, unt: sensorInfo.unit }//d2:sensorInfo.lastData2,d3:sensorInfo.lastData3}
        state.sensorPoints.push(position)
      }
    },
    //地图采集器点
    GETDATALOGGERPOINTS(state, data) {
      state.dataloggerPoints = [];
      for (var i = 0; i < data.length; i++) {
        var dataLoggerInfo = data[i];
        var position = { lng: dataLoggerInfo.longitude, lat: dataLoggerInfo.latitude, type: 'collector', id: dataLoggerInfo.dataloggerId }
        state.dataloggerPoints.push(position)
      }
    },
    //legendData
    GETLEGENDDATA(state, data) {
      state.legendData = [];

      Object.keys(data).sort().forEach(function (key) {
        state.legendData.push(key);
      });

    },
    //chartData
    GETCHARTDATA(state, data) {
      state.chartData = {};

      Object.keys(data).forEach(function (key) {
        state.chartData[key] = [];
        let arr = data[key]
        arr.forEach(function (val, index) {
          let sta_str = val.dataTime.replace(/-/g, "/");
          let sta_date = new Date(sta_str);
          let item = {
            name: val.dataTime.toString(),
            value: [
              sta_date.getTime(),
              val.data
            ]
          }
          state.chartData[key].push(item);
        });
      });

    },
    GETTABLECOLUMNS(state, data) {
      state.tableColumns = [];
      state.tableColumns.push({ title: "时间", field: "time", key: "time", fixed: 'left', width: 200 });
      Object.keys(data).forEach(function (key) {
        state.tableColumns.push({ title: key, key: key, width: 120 });
      });
    },
    GETTABALEDATA(state, data) {
      state.tableData = [];
      let maxkey = "";
      let max = 0;
      Object.keys(data).forEach(function (key) {
        if (data[key].length > max) {
          max = data[key].length;
          maxkey = key;
        }
      });
      let maxItem = data[maxkey];
      if (maxItem) {
        maxItem.forEach(function (val, index) {
          state.tableData.push({ time: val.name });
        });
      }

      state.tableData.forEach(function (val, index) {
        var dataTime = val.time;
        Object.keys(data).forEach(function (key) {
          var row = data[key];
          row.forEach(function (rowVal, idx) {
            if (rowVal.name === dataTime) {
              state.tableData[index][key] = data[key][idx].value[1];
            }
          });
        });
      });

    },
    GETDATALOGGERTAB(state, data) {
      state.dataloggertab = data;
    },
    getDefaultTabId(state, level) {
      state.dataloggertab.forEach(function (val, index) {
        if (val.level == level)
          state.defaultTabId = val.tabId;
      });
    }
  },
  getters: {
    getDataLoggerInfos(state) {
      return state.dataLoggerInfos;
    },
    getDataLoggerPage(state) {
      return state.dataLoggerPage;
    },
    getTreeNodes(state) {
      return state.treeNodes;
    },

    getSensorInfos(state) {
      return state.sensorInfos;
    },
    getSensorPointInfos(state) {
      return state.sensorPoints;
    },
    getDataLoggerPointInfos(state) {
      return state.dataloggerPoints;
    },
    getlegendData(state) {
      return state.legendData;
    },
    getChartData(state) {
      return state.chartData;
    },
    getTableColumns(state) {
      return state.tableColumns;
    },
    getTabledata(state) {
      return state.tableData;
    },
    getdataloggertab(state) {
      return state.dataloggertab;
    },
    getDefaultTabId(state) {
      return state.defaultTabId;
    }
  },
  actions: {
    //根据项目编码获取项目下的采集器
    getDataloggerInfoByPrjIdAction({ commit }, prjId) {
      api.getDataloggerInfoByPrjId(prjId).then(function (response) {
        commit("GETDATALOGGERINFOS", response.body);
        commit("GETDATALOGGERPOINTS", response.body);
        //commit("GETTREENODES", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    //根据采集器编号获取采集器信息
    getDataloggerInfoByLoggerIdAction({ commit }, dataloggerId) {
      api.getDataloggerInfoByLoggerId(dataloggerId,).then(function (response) {

        commit("GETDATALOGGERINFOS", response.body);
        commit("GETDATALOGGERPOINTS", response.body);
        if (response.body[0]) {
          commit("GETSENSORPOINTINFOS", response.body[0].sensorInfos);
        }
      }, function (response) {
        console.log("==error==", response);
      });
    },
    //根据采集器名字获取采集器信息
    getDataloggerInfoByLoggerNameAction({ commit }, dataloggerName) {
      api.getDataloggerInfoByLoggerName(dataloggerName).then(function (response) {

        commit("GETDATALOGGERINFOS", response.body);
        commit("GETDATALOGGERPOINTS", response.body);
        if (response.body[0]) {
          commit("GETSENSORPOINTINFOS", response.body[0].sensorInfos);
        }
      }, function (response) {
        console.log("==error==", response);
      });
    },
    //根据kind和dataloggerid获取一个datalogger下的所有符合kind类型的sensor的数据
    getSameKindSensorInfos({ commit }, param) {
      api.getDataloggerInfoByLoggerName(param.dataloggerName).then(function (response) {
        for (var i = 0; i < response.body.length; ++i) {
          var sensorInfos = response.body[i].sensorInfos;
          var lenth = sensorInfos.length;
          for (var j = 0; j < lenth; ++j) {
            if (sensorInfos[j].unit !== param.unit) {
              sensorInfos.splice(j, 1);
              lenth--;
            }
          }
        }
        commit("GETDATALOGGERINFOS", response.body);
        commit("GETDATALOGGERPOINTS", response.body);
        if (response.body[0]) {
          commit("GETSENSORPOINTINFOS", response.body[0].sensorInfos);
        }
      }, function (response) {
        console.log("==error==", response);
      });
    },
    //查询采集器分页数据
    getDataloggerPageAction({ commit }, param) {
      return api.getDataloggerPageResource(param).then(function (response) {
        commit("GETDATALOGGERPAGE", response.body);
        return response.body
      })
    },
    //根据传感器编号获取传感器信息
    getSensorInfoBySensorIdIdAction({ commit }, id) {
      api.getSensorinfoBySensorId(id).then(function (response) {
        commit("GETSENSORPOINTINFOS", response.body);
        commit("GETLEGENDDATA", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getSensorinfoByPrjIdAction({ commit }, projectId) {
      try {
        api.getSensorinfoByPrjId(projectId).then(function (response) {
          commit("GETSENSORPOINTINFOS", response.body);
        }, function (response) {
          console.log("==error==", response);
        });
      } catch (error) {
        console.log('getAllSensorInfoAction error:', error);
      }
    },
    getSensorByProjectIdAndUserIdAction({ commit }, params) {
      try {
        api.getSensorByProjectIdAndUserId(params).then(function (response) {
          commit("GETSENSORPOINTINFOS", response.body);
        }, function (response) {
          console.log("==error==", response);
        });
      } catch (error) {
        console.log('getSensorByProjectIdAndUserId error:', error);
      }
    },
    getSensorInfoByIdAction({ commit }, id) {
      api.getAllSensorinfoResource(id, '2').then(function (response) {
        commit("GETSENSORPOINTINFOS", response.body);
        commit("GETLEGENDDATA", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getSensorInfoByDataloggerIdAction({ commit }, id) {
      api.getAllSensorinfoResource(id, '3').then(function (response) {
        commit("GETSENSORPOINTINFOS", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getSensordataByLoggerIdAction({ commit }, params) {
      if (params.startTime && params.endTime) {
        api.getSensordataResource(params.id, '1', params.level, params.startTime, params.endTime).then(function (response) {
          //console.log(response.body);
          //更新图形legend名称
          commit("GETLEGENDDATA", response.body);
          //更新图形数据
          commit("GETCHARTDATA", response.body);
          //更新table数据
          commit("GETTABALEDATA", response.body);
          //更新table列名称
          commit("GETTABLECOLUMNS", response.body);
          //aa
          commit("getDefaultTabId", params.level);
        }, function (response) {
          console.log("==error==", response);
        });
      }
    },
    getSensordataBySensorIdAction({ commit }, params) {
      if (params.startTime && params.endTime) {
        api.getSensordataResource(params.id, "2", params.level, params.startTime, params.endTime).then(function (response) {

          //更新图形legend名称
          commit("GETLEGENDDATA", response.body);
          //更新图形数据
          commit("GETCHARTDATA", response.body);
          //更新table数据
          commit("GETTABALEDATA", response.body);
          //更新table列名称
          commit("GETTABLECOLUMNS", response.body);
        }, function (response) {
          console.log("==error==", response);
        });
      }

    },
    getSensordataBySensorIdAndLevelAction({ commit }, params) {
      api.getSensordataByIdLevelResource(params.id, params.level, params.startTime, params.endTime).then(function (response) {
        //更新图形legend名称
        commit("GETLEGENDDATA", response.body);
        //更新图形数据
        commit("GETCHARTDATA", response.body);
        //更新table数据
        commit("GETTABALEDATA", response.body);
        //更新table列名称
        commit("GETTABLECOLUMNS", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    saveDataloggerAction({ dispatch, commit }, dataloggerInfo) {
      let _this = this;
      return api.saveDataloggerResource(dataloggerInfo).then(function (response) {
        // dispatch('getDataloggerPageAction', dataloggerInfo);
        return response.body;
      }, function (response) {
        console.log("==error==", response);
        return response;
      });
    },
    updateDataloggerAction({ dispatch, commit }, dataloggerInfo) {
      return api.updateDataloggerResource(dataloggerInfo).then(function (response) {
        return response.body;
      }, function (response) {
        console.log("==error==", response);
        return response;
      });
    },
    delDataloggerAction({ dispatch, commit }, params) {
      let _this = this;
      return api.delDataloggerResource(params).then(function (response) {
        // dispatch('getDataloggerPageAction', _this.params);
        return response.body;
      }, function (response) {
        console.log("==error==", response);
        return response;
      });

    },
    getDataloggertabAction({ commit }, id) {
      api.getDataloggertabResource(id).then(function (response) {
        commit("GETDATALOGGERTAB", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getDataloggertabBylevelAction({ commit }, param) {
      api.getDataloggertabBylevelResource(param.id, param.level).then(function (response) {
        commit("GETDATALOGGERTAB", response.body);
        commit("getDefaultTabId", param.level);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    //根据项目编号获取设备列表树
    getRootTreeNodeAction({ commit }, prjId) {
      api.getRootTreeNodeResource(prjId).then(function (response) {
        commit("GETTREENODES", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    }
  }
};

export default datalogger;



// WEBPACK FOOTER //
// ./src/store/modules/datalogger.js